<template>
  <div class="app-container">

    <!--<el-page-header @back="$router.go(-1)" :content="'作业详情&#45;&#45;'+projectionRow.title"></el-page-header>-->
    <div class="el-page-header">
      <div class="el-page-header__left" @click="$router.go(-1)">
        <i class="el-icon-back"></i>
        <div class="el-page-header__title">
          返回
        </div>
      </div>
      <div class="el-page-header__content">
        <slot name="content">项目成绩管理--{{ projectionRow.title }} </slot>
      </div>
      <div class="" style="position: absolute; right: 0; cursor: pointer;" @click="handleToScore(projectionRow)">
        <div></div>

        <el-button size="mini"  >项目考核规则</el-button>
      </div>
    </div>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="成绩册" name="achievement">

        <section class="el-tab-pane-section">


          <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="70">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="queryParams.name" placeholder="请输入" clearable size="small" @input="changeVal()"/>
            </el-form-item>

            <el-form-item label="手机" prop="tel">
              <el-input v-model="queryParams.tel" placeholder="请输入" clearable size="small" @input="changeVal()"/>
            </el-form-item>

            <el-form-item label="省市区" prop="type">
              <el-cascader v-model="areaTreeId" :options="areaTreeOptions"  :props="{ checkStrictly: true }"  size="small" clearable></el-cascader>
            </el-form-item>

            <el-form-item label="单位" prop="unit" >
              <el-select v-model="queryParams.unit" placeholder="请选择单位" clearable filterable size="small" @change="changeVal()">
                <el-option v-for="(item, index) in unitOptions" :key="index" :label="item.name"
                           :value="item.id" :disabled="item.disabled"></el-option>
              </el-select>
            </el-form-item>


            <el-form-item>
              <el-button type="cyan" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
          </el-form>

          <el-row  class="mb8">
            <el-col :span="1.5" class="ml5">
              <el-button type="primary" size="mini" @click="customAdd">自定义表头</el-button>
            </el-col>
            <el-col :span="1.5" class="ml5">
              <el-button type="primary" size="mini" @click="handleExport">导出</el-button>
            </el-col>

            <!-- <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar> -->
          </el-row>


          <el-table v-loading="loading"  :data="postList" @sort-change='sortChange'>
              <div  v-for="(aitem, aindex) in headerList" :key="aindex">
               <el-table-column :label="aitem.c_name" align="center" :prop="aitem.name" :sortable='isSort(aitem.name)' show-overflow-tooltip/>
              </div>
            <el-table-column label="操作" align="center"  width="1px"></el-table-column>
          </el-table>

          <pagination
            v-show="total>0"
            :total="total"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.limit"
            @pagination="getList"
          />

        </section>
      </el-tab-pane>

      <el-tab-pane label="学习情况明细" name="analysis">

        <section class="el-tab-pane-section">

          <index-study-detail :unitOptions="unitOptions" :areaTreeOptions="areaTreeOptions"
                          ref="studyDetailRef"  ></index-study-detail>

        </section>
      </el-tab-pane>
    </el-tabs>


    <!-- 添加或修改岗位对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="850px" append-to-body :close-on-click-modal="false">
      <div slot="footer" class="dialog-footer" >
        <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
        <el-button @click="cancel" size="small">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->


    <!-- 自定义 类型 -->
    <custom-header  :row="customRow" ref="customRef" @getList="getList"></custom-header>
    <assessment :row="assessmentRow" ref="assessments" @getList="getList" ></assessment>

  </div>
</template>

<script>
  import {
    projectAchievementsList,  projectAchievementsHeaderShow, getManage, projectAchievementsListExport
  } from "@/api/tearcher";
  import { getProjectUnitOptions}  from "@/api/tearcher"
  import { getAreaTree } from "@/api/tearcher";

  import customHeader from '../customHeader';
  import indexStudyDetail from './indexStudyDetail'

  import { saveAs } from'file-saver';
  import assessment from './assessment'


  export default {
    name: "projectAchievement",
    components: {
      customHeader, indexStudyDetail, assessment
    },
    data() {
      return {

        // 遮罩层
        loading: true,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        // 显示搜索条件
        showSearch: true,
        // 总条数
        total: 0,
        // 岗位表格数据
        postList: [],
        headerList: [],
        projectId : undefined, // 当前id
        activeName: '',
        title: "", // 弹出层标题
        open: false,  // 是否显示弹出层
        openCustom: false,  // 是否显示弹出层
        headerText : '',
        headerDetailText : '',

        scheduleLab : {},
        projectionRow : {},

        unitOptions: [],
        areaTreeOptions: [], //  省 市 区 树
        areaTreeId: [],


        // 查询参数
        queryParams: {
          page: 1,
          limit: 10,
          title: undefined,
          name: undefined,
          username: undefined,
          class_id : undefined,
        },
        customRow : {},   // 自定义数据
        assessmentRow : {},

      };
    },
    created() {

      this.projectId = this.$route.params && this.$route.params.id;

      if (this.$route.query.name !== undefined)  {
        this.queryParams.name = this.$route.query.name
      } else {
        this.queryParams.name = undefined;
      }

      this.getList();
      this.getProjectData();

      this.activeName = 'achievement'
      // this.activeName = 'answer_details'

      getProjectUnitOptions(this.projectId).then(response => {this.unitOptions = response.data;
      this.unitOptions.push({"id":undefined,"name":'全部'})});
      this.getAreaTreeOptions();
    },

    mounted() {
    },

    computed: {

    },
    methods: {

      /** 查询班级列表 */
      getList() {
        this.loading = true;

        this.queryParams.focus_project_id = this.projectId;
        projectAchievementsList(this.queryParams).then(res => {
          let response = res.data;
          this.postList = response.list;
          this.headerList = response.header;

          this.total = response.total;
          this.loading = false;
        });
      },

      /** 获取 项目详情  */
      getProjectData() {

        getManage({ id: this.projectId, }).then(res => {
          this.projectionRow = res.data;
        });
      },



      // 岗位状态字典翻译
      statusFormat(row, column) {
        return this.selectDictLabel(this.statusOptions, row.status);
      },
      // 取消按钮
      cancel() {
        this.open = false;
        this.reset();
      },

      // 表单重置
      reset() {
        this.form = {};
        this.resetForm("form");
      },

      /** 搜索按钮操作 */
      handleQuery() {
        this.queryParams.page = 1;

        this.queryParams.province_id = undefined;
        this.queryParams.city_id = undefined;
        this.queryParams.area_id = undefined;
        if (typeof this.areaTreeId === 'object' && this.areaTreeId.length > 0) {
          for (let i = 0; i < this.areaTreeId.length; i++) {
            if (i === 0) {
              this.queryParams.province_id = this.areaTreeId[i];
            }
            if (i === 1) {
              this.queryParams.city_id = this.areaTreeId[i];
            }
            if (i === 2) {
              this.queryParams.area_id = this.areaTreeId[i]
            }
          }
        }

        this.getList();
      },
      /** 重置按钮操作 */
      resetQuery() {
        this.resetForm("queryForm");
        this.queryParams.name = undefined;
        this.areaTreeId = [];
        this.handleQuery();
      },
      // 多选框选中数据
      handleSelectionChange(selection) {
        this.ids = selection.map(item => item.id)
        this.single = selection.length != 1
        this.multiple = !selection.length
      },
      /** 新增按钮操作 */
      handleAdd() {

        this.$refs.uploadFile.handleImport();
        // this.reset();
        // this.open = true;
        // this.title = "录入自定义考核成绩";
      },

      /** 修改按钮操作 */
      handleUpdate(row) {
        this.scheduleLab = row
        this.$nextTick(function() {
          this.$refs.createSchedule.handleUpdate();
        })
      },
      /** 提交按钮 */
      submitForm: function() {
        this.$refs["form"].validate(valid => {
          if (valid) {
            if (this.form.id != undefined) {

            } else {
            }
          }
        });
      },

      handleClick(tab, event) {

      },

      getAreaTreeOptions() {
        getAreaTree().then(res => {
          this.areaTreeOptions = res.data;
        });
      },



      /** 自定义表头 */
      customAdd() {
        // 明细
        projectAchievementsHeaderShow().then(res => {
          this.customRow = res.data;
          this.$nextTick(function() {
            this.$refs.customRef.handleUpdate();
          })
        });
      },

      handleExport() {
        projectAchievementsListExport(this.queryParams).then(res => {
          saveAs(res, '项目成绩册.xls');
        })
      },

      handleToScore(row) {
          this.assessmentRow = row;
          this.$nextTick(function () {
            this.$refs.assessments.handleUpdate();
          })
      },

      isSort(ext) {
        // 'subject',
        if (['group_title', 'unit', 'province_id', 'city_id', 'area_id', 'level', 'subject', 'truename'].includes(ext)) {
          return 'custom'
        }
        return false;
      },

      sortChange: function(column, prop, order) {
        let paramsOrder = undefined;

        this.queryParams.order_name = undefined;
        this.queryParams.order_unit = undefined;
        this.queryParams.order_group = undefined;
        this.queryParams.order_level = undefined;
        this.queryParams.order_subject = undefined;
        this.queryParams.order_region = undefined;

        switch (column.prop) {
          case 'truename':
            if (column.order === 'descending') {
              this.queryParams.order_name = 1
            } else if (column.order === 'ascending') {
              this.queryParams.order_name = 2
            }
            break;
          case 'unit':
            if (column.order === 'descending') {
              this.queryParams.order_unit = 1
            } else if (column.order === 'ascending') {
              this.queryParams.order_unit = 2
            }
            break;
          case 'group_title':
            if (column.order === 'descending') {
              this.queryParams.order_group = 1
            } else if (column.order === 'ascending') {
              this.queryParams.order_group = 2
            }
            break;
            case 'level':
            if (column.order === 'descending') {
              this.queryParams.order_level = 1
            } else if (column.order === 'ascending') {
              this.queryParams.order_level = 2
            }
            break;
          case 'subject':
            if (column.order === 'descending') {
              this.queryParams.order_subject = 1
            } else if (column.order === 'ascending') {
              this.queryParams.order_subject = 2
            }
            break;
          case 'province_id':
          case 'city_id':
          case 'area_id':
            if (column.order === 'descending') {
              this.queryParams.order_region = 1
            } else if (column.order === 'ascending') {
              this.queryParams.order_region = 2
            }
            break;
          default:
            paramsOrder = undefined;
        }
        this.getList();
      },

      changeVal(){
        this.$forceUpdate();
      },

    },
    watch: {
    }
  };
</script>

<style lang="less" scoped>

  .app-container {
    padding: 25px;
  }

  .header-title {
    font-size: 14px;
    margin-bottom: 10px;
    /* margin-left: 15px; */
    color: #303133;
    background-color: #f2f2f2;
    padding: 10px;
  }

  .el-tab-pane-section {
    padding-bottom: 6px;
  }

</style>
